export type SortType = 'ASC' | 'DESC';

export enum SortJobBy {
    None = 'none',
    CreatedDate = 'createdDate',
    DueDate = 'dueDate',
    CompletedDate = 'completedDate',
    SystemPriority = 'systemPriority'
}

export interface SortJobOptions {
    sortBy: SortJobBy;
    sortType: SortType;
}
